import { decodeJwt, deleteCookie } from "@/utils/cookieUtils";
import { TClient } from "@/types/types";
import { setCookie } from "@/utils/cookieUtils";
import MetaMaskSDK from "@metamask/sdk";

export const handleGoogleSignIn = async (
  credentialResponse: any,
  setUserInfo: (userInfo: TClient) => void
) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ credential: credentialResponse.credential }),
  };

  try {
    const response = await fetch(
      `${import.meta.env.VITE_EXPONENTIAL_API_URL}/user/auth`,
      // `https://api.coinharbour.xyz/user/auth`,
      requestOptions
    );
    const result: { token: string } = await response.json();

    // Check if waitlisted
    const jwtPayload = decodeJwt(result.token);

    setCookie("jwt", result.token);
    setUserInfo({
      id: jwtPayload.id,
      name: jwtPayload.name,
      email: jwtPayload.email,
      address: jwtPayload.address,
      has_wallet: false,
      waitlisted: jwtPayload.waitlisted,
    });
  } catch (error) {
    console.error("An error occurred. Please try again later.");
  }
};

export const handleMetamaskSignIn = async (
  setUserInfo: (userInfo: TClient) => void
) => {
  const MMSDK = new MetaMaskSDK();

  try {
    // Step 1: Fetch a unique nonce from the backend
    const nonceResponse = await fetch(
      `${import.meta.env.VITE_EXPONENTIAL_API_URL}/user/metamask`
    );
    const { nonce } = await nonceResponse.json(); // Get nonce as { nonce: "randomstring" }
    if (!nonce) {
      throw new Error("Failed to fetch nonce");
    }

    // Step 2: User signs the nonce message
    const signature = await MMSDK.connectAndSign({
      msg: `Sign in to CoinHarbour: ${nonce}`, // Include nonce in the message
    });

    // Step 3: Send the signature & nonce to the backend for verification
    const response = await fetch(
      `${import.meta.env.VITE_EXPONENTIAL_API_URL}/user/metamask`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          signature,
          message: `Sign in to CoinHarbour: ${nonce}`,
        }),
      }
    );

    if (!response.ok) {
      throw new Error("Failed to authenticate user");
    }

    const { token } = await response.json();
    const jwtPayload = decodeJwt(token);
    setUserInfo({
      id: jwtPayload.id,
      name: jwtPayload.name,
      email: jwtPayload.email,
      address: jwtPayload.address,
      has_wallet: true,
      waitlisted: jwtPayload.waitlisted,
    });
    setCookie("jwt", token);
  } catch (err) {
    console.error("Error with connectAndSign:", err);
  }
};

export const handleLogoout = (setUserInfo: (userInfo: TClient) => void) => {
  deleteCookie("jwt");
  setUserInfo({
    id: 0,
    name: "",
    email: "",
    address: "",
    has_wallet: false,
    waitlisted: true,
  });
  window.location.href = "/";
};
